import {useTranslation} from "react-i18next";
import {Descriptions, Table, Tabs, Tag, Typography} from "antd";
import ReactJson from "react-json-view";
import request from "./request.json"
import React from "react";
import {PostApiCollapsePanel} from "../../../post_api_collapse_panel";

import main_format from "./main_format.json";

import pay_form_format from "./pay_form_format.json"

export const ApiPayFormPost = () => {
    const {t} = useTranslation()

    const ApiTable = ({dataSource}) => {
        return(
            <Table pagination={false} rowKey={'key'} columns={[
                {
                    title: t('key'),
                    dataIndex: 'key',
                },
                {
                    title: t('type'),
                    dataIndex: 'type',
                    render: (type) => {
                        let color = ''
                        switch (type) {
                            case 'string':
                                color = 'orange';
                                break;
                            case 'integer':
                                color = 'blue';
                                break;
                            case 'number':
                                color = 'purple';
                                break;
                            case 'array':
                                color = 'default';
                                break;
                        }
                        return <Tag
                            color={color}
                            key={type}>
                            {type}
                        </Tag>
                    }
                },
                {
                    title: t('is_null'),
                    dataIndex: 'is_null',
                    render: (is_null) => {
                        return <Tag
                            color={is_null === 'true' ? 'green' : 'volcano'}
                            key={is_null}>
                            {t(is_null)}
                        </Tag>

                    }
                },
                {
                    title: t('descriptions'),
                    dataIndex: 'descriptions',
                    render: (descriptions) => <span style={{whiteSpace:'pre-line'}}>{descriptions}</span>
                },
            ]}
                   dataSource={dataSource}
            />
        )
    }

    return (
        <PostApiCollapsePanel name={'pay_forms'} descriptions={t('set_pay_forms')}>
            <Tabs defaultActiveKey="1">
                <Tabs.TabPane tab={t('request')} key="1">
                    <Typography.Title level={5}>{t('model')}</Typography.Title>

                    <ApiTable dataSource={main_format}/>
                    <br/>
                    <br/>

                    {t('pay_form')}
                    <ApiTable dataSource={pay_form_format}/>
                    <br/>
                    <br/>


                    <Typography.Title level={5}>{t('example')}</Typography.Title>
                    <ReactJson
                        src={request}
                        name={null}
                        displayObjectSize={false}
                        displayArrayKey={false}
                        displayDataTypes={false}
                        enableClipboard={false}
                        style={{fontSize: '10pt'}}/>
                </Tabs.TabPane>
                <Tabs.TabPane tab={t('response')} key="3">
                    {t('no_body_response')}
                    <br/>
                    <br/>
                    <Descriptions bordered size={'small'}>
                        <Descriptions.Item label={202}
                                           span={3}>{t('data_loaded')}</Descriptions.Item>
                        <Descriptions.Item label={403}
                                           span={3}>{t('authorisation_error')}</Descriptions.Item>
                        <Descriptions.Item label={406}
                                           span={3}>{t('error_json_format')}</Descriptions.Item>
                    </Descriptions>
                </Tabs.TabPane>
            </Tabs>
        </PostApiCollapsePanel>
    )
}